import { commonShortFieldLabels, commonShortNouns } from "./common-short-fields";

export const examAdminAttemptDetail = {
  pageTitle: "作答详情",
  notFound: "未找到对应作答记录。",
  sections: {
    summary: "作答摘要",
    deliverySnapshot: "投放快照",
    scoreRecords: "评分记录",
    judgeSubmissions: "代码提交",
    environments: "环境实例",
  },
  fields: {
    paperTitle: "试卷名称",
    paperType: "试卷类型",
    paperVersionCode: "试卷版本编号",
    duration: "考试时长",
    examStartTime: "考试开始时间",
    examEndTime: "考试结束时间",
    deadlineAt: "作答截止时间",
    earliestSubmitAt: "最早可交卷时间",
    exam: "考试",
    candidate: "考生",
    status: commonShortNouns.status,
    reviewStatus: "阅卷状态",
    totalScore: "总分",
    scoreSplit: "客观 / 主观",
    startedAt: "开始时间",
    submittedAt: "提交时间",
    lastSavedAt: "最后保存",
    createdAt: commonShortFieldLabels.createdAt,
    questionId: "题目 ID",
    questionCode: "题目编号",
    versionId: "题目版本编号",
    versionCode: "版本编号",
    questionType: "题型",
    difficulty: "难度",
    questionScore: "题目分值",
    source: "来源",
    scoreSource: "评分来源",
    score: "得分",
    comment: "评语",
    time: "时间",
    submission: "提交",
    judgeStatus: "判题状态",
    instance: "实例",
    type: "类型",
    accessEntry: "访问入口",
  },
  labels: {
    questionTitle: "第 {order} 题 · {title}",
    titleWithId: "作答 #{id}",
    sourceAuto: "自动评分",
    sourceManual: "人工评分",
    sourceReview: "复核评分",
    sourceUnknown: "未知来源",
    statusValid: "生效",
    statusInvalid: "无效",
    statusPending: "待生效",
    statusUnknown: "未知",
    commentAutoObjective: "系统自动客观题评分",
    commentManualReview: "人工复核评分",
    examFallback: "考试 #{id}",
    candidateFallback: "考生 #{id}",
    candidateId: "ID {id}",
    contentRef: "content_ref: {value}",
    policyShuffleQuestions: "题目乱序 {value}",
    policyShuffleOptions: "选项打乱 {value}",
    policySelfCheck: "自主检测 {value}",
    policyMaxSelfCheckCount: "最多运行 {count} 次",
    policyMaxCreateCount: "最多创建环境 {count} 次",
    markCorrect: "正确",
    markCorrectRadioTip: "（点击左侧单选按钮，即标记为正确答案）",
    markCorrectCheckboxTip: "（勾选左侧复选框，即标记为正确答案）",
    practicalQuestionFallback: "实操题调试",
    attackDefenseQuestionFallback: "攻防题调试",
  },
  actions: {
    viewExam: "查看考试",
    viewRawJson: "查看原始 JSON",
    viewLatestAnswerJson: "查看作答原始 JSON",
    viewReferenceAnswerJson: "查看参考答案原始 JSON",
    viewQuestionSnapshotJson: "查看题目快照原始 JSON",
  },
  cards: {
    runtimePolicies: "题型运行策略",
    questionSnapshotAndAnswer: "题目快照与作答",
    questionPreview: "题目预览",
    runtimePolicy: "运行策略",
    answerResult: "作答结果",
    referenceAnswer: "参考答案",
  },
} as const;
